// Lib
import React from 'react';
import { useSelector } from 'react-redux';
import { Sparkles } from 'lucide-react';

// Hooks
import useAIButton from '@hooks/useAIButton';

// Types
import type { RootState } from '@app-types/index';

const GRADIENT = 'bg-[linear-gradient(143.42deg,#DFCCFF_7.32%,#5184FB_96.34%)]';

const AIButton: React.FC = () => {
  const { isLoggedIn } = useSelector((state: RootState) => ({
    isLoggedIn: !!state.Account._id,
  }));

  const { openAIDrawer } = useAIButton();
  // Sits just above the mobile bottom bar (~64px + the home-indicator inset).
  return isLoggedIn ? (
    <div
      role="button"
      tabIndex={0}
      aria-label="Open AI chat"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openAIDrawer();
        }
      }}
      className={`ai-button ai-button-pulse fixed right-6 z-[1] hidden size-14 cursor-pointer items-center justify-center rounded-full border border-white text-white max-[1279px]:bottom-[calc(84px+env(safe-area-inset-bottom))] max-[1279px]:flex ${GRADIENT}`}
      onClick={() => openAIDrawer()}
    >
      <Sparkles className="size-8" aria-hidden />
    </div>
  ) : null;
};

export default AIButton;
